import { IPreference } from './userProfile';

export class UserCreate {
  name: string = '';
  organizationId?: string;
  emailAddress: string = '';
  preference?: IPreference;
}
